import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import { IconButton } from './IconButton'
import { useThemeMode } from './ThemeModeProvider'

// One icon in both modes, the half-light half-dark disc: the clock beside it
// already shows the sun, sunset and moon for the time of day at the field, and
// a toggle that drew the same sun or moon read as another part of that
// display. The label says which way a click goes.
export function ThemeModeToggle() {
  const { t } = useTranslation()
  const { mode, toggleMode } = useThemeMode()
  const label = t(mode === 'light' ? 'common.toggleThemeDark' : 'common.toggleThemeLight')

  return (
    <IconButton onClick={toggleMode} color="inherit" aria-label={label} sx={{ color: 'inherit' }}>
      <Icon icon="mdi:theme-light-dark" width={22} />
    </IconButton>
  )
}
